<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Import người dùng</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="File cần import:"
                                              label-align="left"
                                              :label-cols="4" label-cols-md="2"
                                              :horizontal="true">

                                    <b-form-file v-model="$v.importUser.file.$model"
                                                 class="col-6"
                                                 accept=".xlsx,.xlsm,.xlsb"
                                                 browse-text="Chọn"
                                                 placeholder="Chọn tệp tải lên..."
                                                 :state="$v.importUser.file.$error ? false : null"></b-form-file>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn file để import
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group :label-cols="4" label-cols-md="2"
                                              :horizontal="true">
                                    <b-button v-if="authorize(['ManageimportUser'])" type="submit" variant="primary">Import</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '.' }">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <b-grid :items="dataMessages"
                            :gridOptions="gridOptions"
                            gridName="Danh sách tài liệu hướng dẫn sử dụng"
                            ref="userManualTable">

                        <template v-slot:cell(status)="row">
                            {{  $store.getters.getStatusName(row.item.status ? 1 : 0) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewUserManual'])" size="sm" :to="{ path: `/help/user-manuals/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="authorize(['ManageUserManual'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers, requiredIf } from 'vuelidate/lib/validators'
    import services from '@/utils/services'

    export default {
        name: 'CreateimportUser',
        mixins: [validationMixin, mixins],
        data() {
            return {
                importUser: {
                    file: null,
                },
                dataMessages: [],
                gridOptions: {
                    fields: [
                        { key: 'rowNumber', label: 'Dòng', sortable: true, sortDirection: 'asc' },
                        { key: 'message', label: 'Thông báo', sortable: false, },
                        { key: 'status', label: 'Trạng thái', sortable: true, },
                    ],
                    sortBy: 'rowNumber',
                },
            }
        },
        validations: {
            importUser: {
                file: {
                    required,
                },
            },
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.upload('master-data/import-user', vm.getFormData(vm.importUser)).done((data) => {
                        vm.$toastr.s('Thêm mới tài liệu thành công');
                        //vm.cancel();
                        vm.dataMessages = data || [];
                    });
                }
            },
            getFormData(object) {
                const formData = new FormData();
                Object.keys(object).forEach(key => formData.append(key, object[key]));
                return formData;
            },
        }
    }
</script>
<style scoped>
</style>
